module.exports = __webpack_public_path__ + "static/media/QRcode4.536bf01e.png";